import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

function CommentEditHistoryModal({ show, onClose, chartId, commentId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !chartId || !commentId) return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_HOST}/charts/${chartId}/comments/${commentId}/edit-history`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      mode: "cors",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setHistory(data.data ?? []);
        } else {
          window.toastr.error(data?.message ?? "Could not load edit history");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [show, chartId, commentId]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">Comment Edit History</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body scroll-y" style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {loading && <p className="text-muted mb-0">Loading history...</p>}
        {!loading && history.length === 0 && <p className="text-muted mb-0">No edits recorded for this comment.</p>}
        {!loading &&
          history.map((entry, index) => (
            <div key={entry.id ?? index} className={`border border-dashed border-gray-300 rounded p-4 ${index !== history.length - 1 ? "mb-4" : ""}`}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-bold">
                  {entry.editor_first_name} {entry.editor_last_name}
                </span>
                <small className="text-muted">{entry.edited_at}</small>
              </div>
              <div className="mb-2">
                <small className="text-muted d-block">Previous</small>
                <span className="text-gray-600 text-break text-decoration-line-through">{entry.previous_comment_msg}</span>
              </div>
              <div>
                <small className="text-muted d-block">Updated to</small>
                <span className="text-gray-800 text-break">{entry.new_comment_msg}</span>
              </div>
            </div>
          ))}
      </Modal.Body>
    </Modal>
  );
}

export default CommentEditHistoryModal;
